module.exports = __webpack_public_path__ + "img/by.by0bc2341.svg";